import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Col, Row, Spin } from "antd";

import DashboardApi from "../../../../apis/Dashboard.api";

const ReviewDashboard = () => {
  const history = useHistory();
  const isLoading = useSelector((state) => state.common.loading);
  const user = useSelector((state) => state.auth.user);

  const [reviewCount, setReviewCount] = useState({
    week: 0,
    high: 0,
    total_high: 0,
    low: 0,
    total_low: 0,
  });

  useEffect(() => {
    getReview();
  }, []);

  const getReview = async () => {
    let param = {
      userId: user.id === 724 ? 1 : user.id,
    };
    const res = await DashboardApi.readReview(param);
    if (res.code === 200) {
      setReviewCount({
        week: res.result.week_score,
        high: res.result.high_score,
        total_high: res.result.total_high_score,
        low: res.result.low_score,
        total_low: res.result.total_low_score,
      });
    }
  };
  return (
    <Row className="order-component-box main-component-box">
      {isLoading && <Spin />}
      <div className={`order-component-title-div main-component-title-div`}>
        <h2 className="order-component-title">
          리뷰
          <span
            className={`gray-font`}
            style={{
              marginLeft: "8px",
            }}
          >
            최근 1주일 기준
          </span>
        </h2>
      </div>
      <Col
        className={`main-component-col`}
        style={{
          padding: "1rem 0",
        }}
      >
        <div
          className={`order-component-info`}
          // ${(user.role === "super_admin") ? "main-component-info" : ""}
          style={{
            gap: "1rem",
            padding: "0 1rem",
          }}
        >
          <Row
            className={`order-component-each main-component-each dash-cursor`}
            align={"middle"}
            onClick={() => history.push(`/inquiries/review`)}
          >
            <span>새로 작성된 리뷰</span>
            <div>
              <span style={{ color: "#117ffa", marginRight: "3px" }}>
                <b>{reviewCount.week}</b>
              </span>
              건
            </div>
          </Row>
          <Row
            className={`order-component-each main-component-each dash-cursor`}
            align={"middle"}
            onClick={() => history.push(`/inquiries/review`)}
          >
            <span>평점 높은 리뷰</span>
            <div>
              <span style={{ color: "#117ffa", marginRight: "3px" }}>
                <b>{reviewCount.high}</b>
                {/*({reviewCount.total_high})*/}
              </span>
              건
            </div>
          </Row>
          <Row
            className={`order-component-each main-component-each dash-cursor`}
            align={"middle"}
            onClick={() => history.push(`/inquiries/review`)}
          >
            <span>평점 낮은 리뷰</span>
            <div>
              <span style={{ color: "#117ffa", marginRight: "3px" }}>
                <b>{reviewCount.low}</b>
                {/*({reviewCount.total_low})*/}
              </span>
              건
            </div>
          </Row>
        </div>
        {user && user.role && user.role === "super_admin" && (
          <div
            className={`order-component-info`}
            style={{
              gap: "5px",
              padding: "0 1rem",
              display: "none",
            }}
            id={`review-info`}
          >
            <Row
              className={`order-component-each main-component-each dash-cursor`}
              align={"middle"}
            >
              <span>
                신고리뷰
                <span
                  style={{
                    color: "#fe2b4b",
                    marginLeft: "5px",
                    fontWeight: 500,
                  }}
                >
                  15
                </span>
              </span>
            </Row>
            {[1, 2, 3, 4].map((item, idx) => (
              <Row
                className={`order-component-each main-component-each dash-cursor`}
                align={"middle"}
                key={`reivew-example-${idx}`}
              >
                <span id={`review-question`}>
                  <span>Q </span>
                  안녕하세요 상품에 대한 문의 입니다. 이 제품안녕하세요 상품에
                  대한 문의 입니다. 이 제품
                </span>
              </Row>
            ))}
          </div>
        )}
      </Col>
    </Row>
  );
};
export default ReviewDashboard;
